import React, { useMemo } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';
import { RoundButton } from 'components/Buttons/RoundButton';
import { ReactComponent as CameraIcon } from 'assets/images/camera.svg';
import { ReactComponent as CameraTorchIcon } from 'assets/images/camera-torch.svg';
import { ReactComponent as CameraFlipIcon } from 'assets/images/camera-flip.svg';
import { getCurrentOS } from 'functions/browserPermissions';

export interface VideoControlsProps {
  onCameraClick: () => void;
  onFlashClick?: () => void;
  onFlipClick?: () => void;
  disabledCamera?: boolean;
  flashOn?: boolean;
  className?: string;
}

function VideoControls(props: VideoControlsProps) {
  const enableFlash = useMemo(() => getCurrentOS() === 'android', []);

  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.secondaryBtn}>
        <RoundButton onClick={props.onFlipClick}>
          <CameraFlipIcon />
        </RoundButton>
      </div>
      <div>
        <RoundButton
          onClick={props.onCameraClick}
          disabled={props.disabledCamera}
        >
          <CameraIcon />
        </RoundButton>
      </div>
      <div
        className={clsx(styles.secondaryBtn, {
          [styles.flashOn]: props.flashOn,
        })}
      >
        <RoundButton onClick={props.onFlashClick} disabled={!enableFlash}>
          <CameraTorchIcon />
        </RoundButton>
      </div>
    </div>
  );
}

export default VideoControls;
